import Vue from 'vue'
import Router from 'vue-router'
import AccountantRoutes from './routers/accountants'
import TransactionCategoryRoutes from './routers/transaction-category'

const Layout = () => import('@/view/layout/Layout')
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/view/pages/Dashboard.vue')

// categories
// stores
const Store = () => import(/* webpackChunkName: "stores" */ '@/view/pages/stores/Store.vue')
const ListStore = () => import(/* webpackChunkName: "stores" */ '@/view/pages/stores/ListStore.vue')
const StoreInfo = () =>
  import(/* webpackChunkName: "add-store" */ '@/view/pages/stores/StoreInfo.vue')

// employees
const Employee = () => import('@/view/pages/employees/Employee.vue')
const ListEmployee = () => import('@/view/pages/employees/ListEmployee.vue')
const UpsertEmployee = () => import('@/view/pages/employees/UpsertEmployee.vue')
const ImportExcelEmployee = () => import('@/view/pages/employees/ImportExcelEmployee.vue')

// permissions
const Permission = () => import('@/view/pages/permissions/Permission.vue')
const ListPermission = () => import('@/view/pages/permissions/ListPermission.vue')
const UpsertPermission = () => import('@/view/pages/permissions/UpsertPermission.vue')
const UpsertPermissionV2 = () => import('@/view/pages/permissions/UpsertPermissionV2.vue')
const DayLimitJobTitleUpsert = () => import('@/view/pages/permissions/DayLimitJobTitleUpsert.vue')

// users
const User = () => import('@/view/pages/users/User.vue')
const ListUser = () => import('@/view/pages/users/ListUser.vue')
const AddUser = () => import('@/view/pages/users/UpsertUser.vue')
const UpdateUser = () => import('@/view/pages/users/UpsertUser.vue')

const Categories = () => import('@/view/pages/categories/Categories.vue')
const ListCategory = () => import('@/view/pages/categories/ListCategory.vue')
const AddCategory = () => import('@/view/pages/categories/AddCategory.vue')
const UpdateCategory = () => import('@/view/pages/categories/UpdateCategory.vue')

// products
const Product = () => import('@/view/pages/products/Product.vue')
const ListProducts = () => import('@/view/pages/products/ListProducts.vue')
const AddProduct = () => import('@/view/pages/products/AddProduct.vue')
const CopyProducts = () => import('@/view/pages/products/CopyProducts.vue')
const ImportProduct = () => import('@/view/pages/products/ImportProduct.vue')
const ImportProductCombo = () => import('@/view/pages/products/ImportProductCombo.vue')
const UpdateProduct = () => import('@/view/pages/products/UpdateProduct.vue')
const InventoryDetail4IMEI = () => import('@/view/pages/products/InventoryDetail4IMEI.vue')
const InventoryDetail = () => import('@/view/pages/products/InventoryDetail.vue')
const UpdateID4Imei = () => import('@/view/pages/products/UpdateID4Imei.vue')
const PrintBarcode = () => import('@/view/pages/products/PrintBarcode.vue')
const PrintProductQRCode = () => import('@/view/pages/products/PrintProductQRCode.vue')
const ProductPrint = () => import('@/view/pages/products/ProductPrint.vue')
const PrintIMEIQRCode = () => import('@/view/pages/imeis/PrintIMEIQRCode.vue')
const PrintIMEIBarCode = () => import('@/view/pages/imeis/PrintIMEIBarCode.vue')
// Image routes
const Image = () => import('@/view/pages/image/Image.vue')
const ImageList = () => import('@/view/pages/image/ImageList.vue')
const ImageUpload = () => import('@/view/pages/image/ImageUpload.vue')
const ImageDetail = () => import('@/view/pages/image/ImageDetail.vue')

// Inventory Receipt
const InventoryReceipt = () =>
  import('@/view/pages/stock-slips/inventory-receipt/InventoryReceipt.vue')
const InventoryReceiptList = () => import('@/view/pages/stock-slips/inventory-receipt/List.vue')
const InventoryReceiptForm = () => import('@/view/pages/stock-slips/inventory-receipt/Form.vue')

// Inventory Dispatch
const InventoryDispatch = () =>
  import('@/view/pages/stock-slips/inventory-dispatch/InventoryDispatch.vue')
const InventoryDispatchList = () => import('@/view/pages/stock-slips/inventory-dispatch/List.vue')
const InventoryDispatchForm = () => import('@/view/pages/stock-slips/inventory-dispatch/Form.vue')

// Inventory Transfer
const InventoryTransfer = () =>
  import('@/view/pages/stock-slips/inventory-transfer/InventoryTransfer.vue')
const InventoryTransferList = () => import('@/view/pages/stock-slips/inventory-transfer/List.vue')
const InventoryTransferForm = () => import('@/view/pages/stock-slips/inventory-transfer/Form.vue')
const InventoryTransferApproval = () =>
  import('@/view/pages/stock-slips/inventory-transfer/Approval.vue')
const InventoryTransferConfirm = () =>
  import('@/view/pages/stock-slips/inventory-transfer/Confirm.vue')
const PrintInventoryTransfer = () =>
  import('@/view/pages/stock-slips/inventory-transfer/PrintInventoryTransfer.vue')

// Inventory Request Transfer
const RequestTransfer = () =>
  import('@/view/pages/stock-slips/request-transfer/RequestTransfer.vue')
const RequestTransferList = () => import('@/view/pages/stock-slips/request-transfer/List.vue')
const RequestTransferForm = () => import('@/view/pages/stock-slips/request-transfer/Form.vue')

// Defective Goods Transfer
const DefectiveGoodsTransfer = () =>
  import('@/view/pages/defective-goods-transfers/DefectiveGoodsTransfer.vue')
const DefectiveGoodsTransferList = () => import('@/view/pages/defective-goods-transfers/List.vue')
const DefectiveGoodsTransferForm = () => import('@/view/pages/defective-goods-transfers/Form.vue')

// Defective Goods Export
const DefectiveGoodsExport = () => import('@/view/pages/defective-goods-export/DefectiveGoods.vue')
const DefectiveGoodsExportList = () => import('@/view/pages/defective-goods-export/List.vue')
const DefectiveGoodsExportForm = () => import('@/view/pages/defective-goods-export/Form.vue')

// Defective Goods Restoration
const DefectiveGoodsRestoration = () =>
  import('@/view/pages/defective-goods-restorations/Restoration.vue')
const DefectiveGoodsRestorationList = () =>
  import('@/view/pages/defective-goods-restorations/List.vue')
const DefectiveGoodsRestorationForm = () =>
  import('@/view/pages/defective-goods-restorations/Form.vue')

// Lending Stockslip
const LendingStockslip = () => import('@/view/pages/lending-stockslip/Lending.vue')
const LendingStockslipList = () => import('@/view/pages/lending-stockslip/List.vue')
const LendingStockslipForm = () => import('@/view/pages/lending-stockslip/Form.vue')

// Opening Stock Receipt
const OpeningStockReceipt = () =>
  import('@/view/pages/stock-slips/opening-stock-receipt/OpeningStock.vue')
const OpeningStockReceiptList = () =>
  import('@/view/pages/stock-slips/opening-stock-receipt/List.vue')
const OpeningStockReceiptForm = () =>
  import('@/view/pages/stock-slips/opening-stock-receipt/Form.vue')
const OpeningStockReceiptIMEIForm = () =>
  import('@/view/pages/stock-slips/opening-stock-receipt/IMEIForm.vue')

// Print StockSlip
const StockSlipInvoice = () => import('@/view/pages/stock-slips/prints/StockSlipInvoice.vue')

// Customer routes
const Customer = () => import('@/view/pages/customers/Customer.vue')
const ListCustomer = () => import('@/view/pages/customers/ListCustomer.vue')
const AddCustomer = () => import('@/view/pages/customers/AddCustomer.vue')
const UpdateCustomer = () => import('@/view/pages/customers/UpdateCustomer.vue')

// Point Promotion
const PointPromotion = () => import('@/view/pages/promotions-point/Point.vue')
const PointSetting = () => import('@/view/pages/promotions-point/PointSetting.vue')
const AddPointPromotion = () => import('@/view/pages/promotions-point/AddPointProgram.vue')
const UpdatePointPromotion = () => import('@/view/pages/promotions-point/UpdatePointProgram.vue')

// Product Stock
const ProductStock = () => import('@/view/pages/stocks/ProductStock.vue')
const ListProductStock = () => import('@/view/pages/stocks/ListProductStock.vue')

const InventoryCostRecalculation = () =>
  import('@/view/pages/stock-slips/inventory-cost-recalculation/InventoryCostRecalculation.vue')
const ListInventoryCostRecalculation = () =>
  import('@/view/pages/stock-slips/inventory-cost-recalculation/ListInventoryCostRecalculation.vue')

const OpeningBalanceCost = () =>
  import('@/view/pages/stock-slips/opening-balance-cost/OpeningBalanceCost.vue')
const ListOpeningBalanceCost = () =>
  import('@/view/pages/stock-slips/opening-balance-cost/ListOpeningBalanceCost.vue')
const FormOpeningBalanceCost = () =>
  import('@/view/pages/stock-slips/opening-balance-cost/FormOpeningBalanceCost.vue')

// IMEI
const Imei = () => import('@/view/pages/imeis/Imei.vue')
const ListImei = () => import('@/view/pages/imeis/ListImei.vue')
const PrintIMEI = () => import('@/view/pages/imeis/PrintIMEI.vue')
const UpdateImei = () => import('@/view/pages/imeis/UpdateImei.vue')
const ProductionOrder = () => import('@/view/pages/imeis/production-order/ProductionOrder.vue')
const ProductionOrderList = () => import('@/view/pages/imeis/production-order/ProductionOrderList.vue')
const ImportChangeProductImei = () => import('@/view/pages/imeis/ImportChangeProduct.vue')
const ImeiHistory = () => import('@/view/pages/imeis/ImeiHistory.vue')
const ListImeiHistory = () => import('@/view/pages/imeis/ListImeiHistory.vue')

import approvalConfigRoutes from '@/view/pages/approval-configs/router'
import approvalRouter from '@/view/pages/approvals/router'
import reportRouters from '@/view/pages/reports/routers'

import debtRouters from './view/pages/debt/routers'
import providerRouters from './view/pages/providers/routers'
import supplierGroupRouters from './view/pages/supplier-group/routers'
import einvoiceRoutes from '@/view/pages/einvoice/router'
import customerTypeRouters from './view/pages/customer-type/routers'
import accessSettingsRouters from './view/pages/access-settings/routers'

// Order
const Order = () => import('@/view/pages/order/Order.vue')
const ListOrder = () => import('@/view/pages/order/ListOrder.vue')
const UpsertOrder = () => import('@/view/pages/order/UpsertOrder.vue')
const UpdateOrder = () => import('@/view/pages/order/UpdateOrder.vue')
const PrintOrderV1 = () => import('@/view/pages/order/PrintOrderV1.vue')

// Order History
const OrderHistory = () => import('@/view/pages/order/history/OrderHistory.vue')
const ListOrderHistory = () => import('@/view/pages/order/history/ListOrderHistory.vue')
const DetailOrderHistory = () => import('@/view/pages/order/history/DetailOrderHistory.vue')

// order-source
const OrderSource = () => import('@/view/pages/order-source/OrderSource.vue')
const ListOrderSource = () => import('@/view/pages/order-source/ListOrderSource.vue')

// flexible-combo
const FlexibleCombo = () => import('@/view/pages/flexible-combo/FlexibleCombo.vue')
const ListFlexibleCombo = () => import('@/view/pages/flexible-combo/List.vue')
const InfoFlexibleCombo = () => import('@/view/pages/flexible-combo/Info.vue')

// pre-order
const PreOrder = () => import('@/view/pages/order/Order.vue')
const ListPreOrder = () => import('@/view/pages/pre-orders/PreOrder.vue')

// trade-in-program
const TradeInProgram = () => import('@/view/pages/trade-in-program/TradeInProgram.vue')
const ListTradeInProgram = () => import('@/view/pages/trade-in-program/List.vue')
const AddTradeInProgram = () => import('@/view/pages/trade-in-program/Add.vue')
const UpdateTradeInProgram = () => import('@/view/pages/trade-in-program/Update.vue')

// trade-in
const TradeIn = () => import('@/view/pages/trade-in/TradeIn.vue')
const ListTradeIn = () => import('@/view/pages/trade-in/List.vue')
const UpdateTradeIn = () => import('@/view/pages/trade-in/Update.vue')
const ImportTradeIn = () => import('@/view/pages/trade-in/ImportTradeIn.vue')

// import trade in
const ITradeIn = () => import('@/view/pages/trade-in/ITradeIn.vue')
const ListITradeIn = () => import('@/view/pages/trade-in/ListITradeIn.vue')
const UpdateImportTradeIn = () => import('@/view/pages/trade-in/UpdateImportTradeIn.vue')
const PrintImportTradeIn = () => import('@/view/pages/trade-in/PrintImportTradeIn.vue')
// bills
const Bill = () => import('@/view/pages/bills/Bill.vue')
const RefundBill = () => import('@/view/pages/bills/refunds/RefundBill.vue')
const ExchangeBill = () => import('@/view/pages/bills/exchange/ExchangeBill.vue')
const ListBill = () => import('@/view/pages/bills/List.vue')
const WholesaleInvoice = () => import('@/view/pages/bills/WholesaleInvoice.vue')

//setting
const Setting = () => import('@/view/pages/settings/Setting.vue')
const SettingInfo = () => import('@/view/pages/settings/Info.vue')
const ShippingCarrierSettings = () => import('@/view/pages/settings/ShippingCarrierSettings.vue')

// warranty
const WarrantyReceptionInfo = () => import('@/view/pages/warranty/WarrantyReceptionInfo.vue')
const WarrantyInfo = () => import('@/view/pages/warranty/WarrantyInfo.vue')

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      component: Layout,
      children: [
        {
          path: '/import-trade-in',
          component: ITradeIn,
          children: [
            {
              path: '/',
              name: 'list-import-trade-in',
              component: ListITradeIn,
              meta: {
                title: 'Danh sách phiếu thu cũ - CLICKBUY',
              },
            },
            {
              path: 'update-import-trade-in',
              name: 'update-import-trade-in',
              component: UpdateImportTradeIn,
              meta: {
                title: 'Cập nhật phiếu thu cũ - CLICKBUY',
              },
            },
            {
              path: 'print-import-trade-in',
              name: 'print-import-trade-in',
              component: PrintImportTradeIn,
              meta: {
                title: 'In phiếu thu cũ - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/trade-in',
          component: TradeIn,
          children: [
            {
              path: '/',
              name: 'list-trade-in',
              component: ListTradeIn,
              meta: {
                title: 'Danh sách phiếu định giá - CLICKBUY',
              },
            },
            {
              path: 'update',
              name: 'update-trade-in',
              component: UpdateTradeIn,
              meta: {
                title: 'Thêm mới phiếu định giá - CLICKBUY',
              },
            },
            {
              path: 'import-trade-in',
              name: 'import-trade-in',
              component: ImportTradeIn,
              meta: {
                title: 'Tạo phiếu thu cũ - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/trade-in-programs',
          component: TradeInProgram,
          children: [
            {
              path: '/',
              name: 'list-trade-in-program',
              component: ListTradeInProgram,
              meta: {
                title: 'Danh sách chương trình thu cũ - CLICKBUY',
              },
            },
            {
              path: 'add',
              name: 'add-trade-in-program',
              component: AddTradeInProgram,
              meta: {
                title: 'Thêm mới chương trình thu cũ - CLICKBUY',
              },
            },
            {
              path: 'update',
              name: 'update-trade-in-program',
              component: UpdateTradeInProgram,
              meta: {
                title: 'Cập nhật chương trình thu cũ - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/pre-order',
          component: PreOrder,
          children: [
            {
              path: '/',
              name: 'list-pre-order',
              component: ListPreOrder,
              meta: {
                title: 'Danh sách đơn hàng đặt trước - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/flexible-combo',
          component: FlexibleCombo,
          children: [
            {
              path: '/',
              name: 'list-flexible-combo',
              component: ListFlexibleCombo,
              meta: {
                title: 'Cấu hình bộ combo - CLICKBUY',
              },
            },
            {
              path: 'info-flexible-combo',
              name: 'info-flexible-combo',
              component: InfoFlexibleCombo,
              meta: {
                title: 'Thông tin cấu hình bộ combo - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/deal-sheets',
          component: () => import('@/view/pages/dealsheets/DealSheet.vue'),
          children: [
            {
              path: '/',
              name: 'deal-sheets',
              component: () => import('@/view/pages/dealsheets/List.vue'),
              meta: {
                title: 'Danh sách DealSheet - CLICKBUY',
              },
            },
            {
              path: 'info-deal-sheet',
              name: 'info-deal-sheet',
              component: () => import('@/view/pages/dealsheets/Info.vue'),
              meta: {
                title: 'Thông Tin DealSheet - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/warranty-receptions',
          component: () => import('@/view/pages/warranty/Warranty.vue'),
          children: [
            {
              path: '/',
              name: 'warranty-receptions',
              component: () => import('@/view/pages/warranty/ListWarrantyReception.vue'),
              meta: {
                title: 'Danh sách Tiếp nhận - CLICKBUY',
              },
            },
            {
              path: 'info',
              name: 'warranty-reception-info',
              component: WarrantyReceptionInfo,
              meta: {
                title: 'Thông tin phiếu tiếp nhận - CLICKBUY',
              },
            },
            {
              path: 'print',
              name: 'print-warranty-reception',
              component: () => import('@/view/pages/warranty/PrintWarrantyReception.vue'),
              meta: {
                title: 'In phiếu tiếp nhận bảo hành',
              },
            },
          ],
        },
        {
          path: '/warranty-rejections',
          component: () => import('@/view/pages/warranty/Warranty.vue'),
          children: [
            {
              path: '/',
              name: 'warranty-rejections',
              component: () => import('@/view/pages/warranty/ListWarrantyRejection.vue'),
              meta: {
                title: 'Danh sách Từ chối bảo hành - CLICKBUY',
              },
            },
            {
              path: 'info',
              name: 'warranty-rejection-info',
              component: () => import('@/view/pages/warranty/WarrantyRejectionInfo.vue'),
              meta: {
                title: 'Tạo phiếu từ chối bảo hành - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/warranty-dispatches',
          component: () => import('@/view/pages/warranty/Warranty.vue'),
          children: [
            {
              path: '/',
              name: 'warranty-dispatches',
              component: () => import('@/view/pages/warranty/ListWarranty.vue'),
              meta: {
                title: 'Danh sách Điều phối - CLICKBUY',
              },
            },
            {
              path: 'info',
              name: 'warranty-dispatch-info',
              component: WarrantyInfo,
              meta: {
                title: 'Chi tiết Điều phối - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/warranty-outsource',
          component: () => import('@/view/pages/warranty/Warranty.vue'),
          children: [
            {
              path: '/',
              name: 'warranty-outsource-list',
              component: () => import('@/view/pages/warranty/outsource/ListOutsource.vue'),
              meta: {
                title: 'Danh sách phiếu outsource - CLICKBUY',
              },
            },
            {
              path: 'info',
              name: 'warranty-outsource-info',
              component: () => import('@/view/pages/warranty/outsource/OutsourceDetail.vue'),
              meta: {
                title: 'Chi tiết phiếu outsource - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/warranty-reports',
          component: () => import('@/view/pages/warranty/Warranty.vue'),
          children: [
            {
              path: 'summary',
              name: 'warranty-report-summary',
              component: () => import('@/view/pages/warranty/reports/ReportSummary.vue'),
              meta: {
                title: 'Báo cáo tiền - CLICKBUY',
              },
            },
            {
              path: 'by-employee',
              name: 'warranty-report-by-employee',
              component: () => import('@/view/pages/warranty/reports/ListReportByEmployee.vue'),
              meta: {
                title: 'Báo cáo theo nhân viên - CLICKBUY',
              },
            },
            {
              path: 'detail',
              name: 'warranty-report-detail',
              component: () => import('@/view/pages/warranty/reports/WarrantyReportDetail.vue'),
              meta: {
                title: 'Báo cáo tổng hợp - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/order-source',
          component: OrderSource,
          children: [
            {
              path: '/',
              name: 'list-order-source',
              component: ListOrderSource,
              meta: {
                title: 'Danh sách nguồn đơn hàng - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/orders',
          component: Order,
          children: [
            {
              path: '/',
              name: 'list-order',
              component: ListOrder,
              meta: {
                title: 'Danh sách đơn hàng - CLICKBUY',
              },
            },
            {
              path: 'edit-order/:id',
              name: 'edit-order',
              component: UpsertOrder,
              meta: {
                title: 'Chỉnh sửa đơn hàng - CLICKBUY',
              },
              props: true,
            },
            {
              path: 'add-order',
              name: 'add-order',
              component: UpsertOrder,
              meta: {
                title: 'Thêm mới đơn hàng - CLICKBUY',
              },
            },
            {
              path: 'update-order',
              name: 'update-order',
              component: UpdateOrder,
              meta: {
                title: 'Cập nhật đơn hàng - CLICKBUY',
              },
            },
            {
              path: 'print-order',
              name: 'print-order',
              component: PrintOrderV1,
              meta: {
                title: 'In đơn hàng - CLICKBUY',
              },
            },
            {
              path: 'platform',
              name: 'list-order-platform',
              component: () => import('@/view/pages/order/ListOrderPlatform.vue'),
              meta: {
                title: 'Danh sách đơn sàn - CLICKBUY',
                requiresAuth: true,
              },
            },
          ],
        },
        {
          path: '/imei-histories',
          component: ImeiHistory,
          children: [
            {
              path: '/',
              name: 'list-imei-history',
              component: ListImeiHistory,
              meta: {
                title: 'Lịch sử IMEI - Clickbuy',
              },
            },
          ],
        },
        {
          path: '/imeis',
          component: Imei,
          children: [
            {
              path: '/',
              name: 'list-imeis',
              component: ListImei,
              meta: {
                title: 'Danh sách IMEI - CLICKBUY',
              },
            },
            {
              path: 'update-imei',
              name: 'update-imei',
              component: UpdateImei,
              meta: {
                title: 'Cập nhật IMEI - CLICKBUY',
              },
            },
            {
              path: 'production-order',
              name: 'production-order',
              component: ProductionOrder,
              meta: {
                title: 'Lệnh sản xuất - CLICKBUY',
              },
            },
            {
              path: 'production-order-list',
              name: 'production-order-list',
              component: ProductionOrderList,
              meta: {
                title: 'Danh sách lệnh sản xuất - CLICKBUY',
              },
            },
            {
              path: 'change-product-imei',
              name: 'change-product-imei',
              redirect: to => ({
                name: 'production-order',
                query: { ...to.query, tab: 'change-product' },
              }),
            },
            {
              path: 'import-change-product-imei',
              name: 'import-change-product-imei',
              component: ImportChangeProductImei,
              meta: {
                title: 'Import đổi sản phẩm IMEI - CLICKBUY',
              },
            },
            {
              path: 'print-imei',
              name: 'print-imei',
              component: PrintIMEI,
              meta: {
                title: 'In IMEI - CLICKBUY',
              },
            },
            {
              path: 'print-imei-qrcode',
              name: 'print-imei-qrcode',
              component: PrintIMEIQRCode,
              meta: {
                title: 'In mã IMEI - CLICKBUY',
              },
              props: true,
            },
            {
              path: 'print-imei-barcode',
              name: 'print-imei-barcode',
              component: PrintIMEIBarCode,
              meta: {
                title: 'In mã IMEI - CLICKBUY',
              },
              props: true,
            },
          ],
        },
        {
          path: '/productStock',
          component: ProductStock,
          children: [
            {
              path: '',
              name: 'list-product-stock',
              component: ListProductStock,
              meta: {
                title: 'Danh sách tồn kho - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/inventory-cost-recalculation',
          component: InventoryCostRecalculation,
          children: [
            {
              path: '',
              name: 'list-inventory-cost-recalculation',
              component: ListInventoryCostRecalculation,
              meta: {
                title: 'Giá vốn theo kỳ - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/opening-balance-cost',
          component: OpeningBalanceCost,
          children: [
            {
              path: '',
              name: 'list-opening-balance-cost',
              component: ListOpeningBalanceCost,
              meta: {
                title: 'Giá vốn đầu kỳ - CLICKBUY',
              },
            },
            {
              path: 'add-opening-balance-cost',
              name: 'add-opening-balance-cost',
              component: FormOpeningBalanceCost,
              meta: {
                title: 'Nhập giá vốn SP đầu kỳ - CLICKBUY',
              },
            },
            {
              path: 'add-opening-imei-balance-cost',
              name: 'add-opening-imei-balance-cost',
              component: FormOpeningBalanceCost,
              meta: {
                title: 'Nhập giá vốn IMEI đầu kỳ - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/inventory-check',
          component: () => import('@/view/pages/inventoryCheck/InventoryCheck.vue'),
          children: [
            {
              path: '',
              name: 'list-inventory-check',
              component: () => import('@/view/pages/inventoryCheck/ListInventoryCheck.vue'),
              meta: {
                title: 'Danh sách phiếu kiểm tra tồn kho',
              },
            },
            {
              path: 'upsert',
              name: 'upsert-inventory-check',
              component: () => import('@/view/pages/inventoryCheck/UpsertInventoryCheck.vue'),
              meta: {
                title: 'Phiếu kiểm tra tồn kho',
              },
            },
            {
              path: 'print',
              name: 'print-inventory-check',
              component: () => import('@/view/pages/inventoryCheck/PrintInventoryCheck.vue'),
              meta: {
                title: 'In biên bản kiểm kê',
              },
            },
            {
              path: 'balance',
              name: 'balance-inventory-check',
              component: () => import('@/view/pages/inventoryCheck/InventoryCheckBalance.vue'),
              meta: {
                title: 'Bù trừ kiểm kho',
              },
            },
          ],
        },
        {
          path: '/points',
          component: PointPromotion,
          children: [
            {
              path: '/',
              name: 'point-setting',
              component: PointSetting,
              meta: {
                title: 'Điểm tích lũy',
              },
            },
            {
              path: 'add-point-program',
              name: 'add-point-program',
              component: AddPointPromotion,
              meta: {
                title: 'Chương trình điểm tích lũy',
              },
            },
            {
              path: 'update-point-program',
              name: 'update-point-program',
              component: UpdatePointPromotion,
              meta: {
                title: 'Cập nhật chương trình điểm tích lũy',
              },
            },
          ],
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard,
        },
        {
          path: '/products',
          component: Product,
          children: [
            {
              path: '/',
              name: 'list-products',
              component: ListProducts,
              meta: {
                title: 'Danh sách sản phẩm - CLICKBUY',
                noFlex: true,
              },
            },
            {
              path: 'add-product',
              name: 'addProduct',
              component: AddProduct,
              meta: {
                title: 'Thêm mới sản phẩm - CLICKBUY',
              },
            },
            {
              path: 'import-product',
              name: 'import-product',
              component: ImportProduct,
              meta: {
                title: 'Nhập sản phẩm - CLICKBUY',
              },
            },
            {
              path: 'copy-products',
              name: 'copy-products',
              component: CopyProducts,
              meta: {
                title: 'Sao chép sản phẩm - CLICKBUY',
              },
            },
            {
              path: 'import-product-combo',
              name: 'import-product-combo',
              component: ImportProductCombo,
              meta: {
                title: 'Nhập sản phẩm combo - CLICKBUY',
              },
            },
            {
              path: 'product-store-pricing-import',
              name: 'product-store-pricing-import',
              component: () => import('@/view/pages/product-store-pricing/index.vue'),
              meta: {
                title: 'Import cấu hình giá sản phẩm - CLICKBUY',
              },
            },
            {
              path: 'update-product',
              name: 'update-product',
              component: UpdateProduct,
              meta: {
                title: 'Cập nhật sản phẩm - CLICKBUY',
              },
            },
            {
              path: 'inventory-detail-imei',
              name: 'inventory-detail-imei',
              component: InventoryDetail4IMEI,
              meta: {
                title: 'Chi tiết tồn kho sản phẩm IMEI - CLICKBUY',
              },
            },
            {
              path: 'inventory-detail',
              name: 'inventory-detail',
              component: InventoryDetail,
              meta: {
                title: 'Chi tiết tồn kho sản phẩm - CLICKBUY',
              },
            },
            {
              path: 'update-inventory-detail',
              name: 'update-inventory-detail',
              component: UpdateID4Imei,
              meta: {
                title: 'Chi tiết IMEI - CLICKBUY',
              },
            },
            {
              path: 'print-barcode',
              name: 'print-barcode',
              component: PrintBarcode,
              meta: {
                title: 'In mã vạch sản phẩm - CLICKBUY',
              },
              props: true,
            },
            {
              path: 'print-price-product',
              name: 'print-price-product',
              component: () => import('@/view/pages/products/PrintPriceProduct.vue'),
              meta: {
                title: 'In bảng giá sản phẩm - CLICKBUY',
              },
              props: true,
            },
            {
              path: 'print-product',
              name: 'print-product',
              component: ProductPrint,
              meta: {
                title: 'In sản phẩm - CLICKBUY',
              },
            },
            {
              path: 'print-product-qrcode',
              name: 'print-product-qrcode',
              component: PrintProductQRCode,
              meta: {
                title: 'In mã sản phẩm - CLICKBUY',
              },
              props: true,
            },
            {
              path: '/product-component-categories',
              component: () =>
                import('@/view/pages/product-component-categories/ProductComponentCategory.vue'),
              children: [
                {
                  path: '/',
                  name: 'list-product-component-category',
                  component: () => import('@/view/pages/product-component-categories/List.vue'),
                  meta: {
                    title: 'Danh mục linh kiện - Clickbuy',
                  },
                },
              ],
            },
            {
              path: '/product-component',
              component: () => import('@/view/pages/product-component/ProductComponent.vue'),
              children: [
                {
                  path: '/',
                  name: 'list-product-component',
                  component: () => import('@/view/pages/product-component/List.vue'),
                  meta: {
                    title: 'Danh sách linh kiện - Clickbuy',
                  },
                },
                {
                  path: 'import-product-component',
                  name: 'import-product-component',
                  component: () => import('@/view/pages/product-component/Import.vue'),
                  meta: {
                    title: 'Nhập sản phẩm linh kiện - Clickbuy',
                  },
                },
              ],
            },
          ],
        },
        {
          path: '/categories',
          component: Categories,
          children: [
            {
              path: '/',
              name: 'list-category',
              component: ListCategory,
              meta: {
                title: 'Danh mục sản phẩm - CLICKBUY',
              },
            },
            {
              path: 'add-category',
              name: 'add-category',
              component: AddCategory,
              meta: {
                title: 'Thêm mới danh mục sản phẩm  - CLICKBUY',
              },
            },
            {
              path: 'update-category',
              name: 'update-category',
              component: UpdateCategory,
              meta: {
                title: 'Cập nhật danh mục sản phẩm  - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/profile',
          component: () => import('@/view/pages/profile/Profile.vue'),
          children: [
            {
              path: 'change-password',
              name: 'change-password',
              component: () => import('@/view/pages/profile/ChangePassword.vue'),
              meta: {
                title: 'Thay đổi mật khẩu - CLICKBUY',
              },
            },
            {
              path: 'change-store',
              name: 'change-store',
              component: () => import('@/view/pages/profile/ChangeStore.vue'),
              meta: {
                title: 'Chuyển cửa hàng - CLICKBUY',
              },
            },
            {
              path: 'transfer-store-forms',
              name: 'profile-transfer-store-forms',
              component: () => import('@/view/pages/profile/ProfileTransferStoreForms.vue'),
              meta: {
                title: 'Phiếu yêu cầu chuyển cửa hàng - CLICKBUY',
              },
            },
            {
              path: 'transfer-store-forms/edit-form',
              name: 'profile-edit-transfer-store-form',
              component: () =>
                import('@/view/pages/transfer-store-forms/EditTransferStoreForm.vue'),
              meta: {
                title: 'Xem chi tiết đơn chuyển cửa hàng - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/brands',
          component: () => import('@/view/pages/brand/Brand.vue'),
          children: [
            {
              path: '/',
              name: 'list-brand',
              component: () => import('@/view/pages/brand/ListBrand.vue'),
              meta: {
                title: 'Danh sách thương hiệu - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/images',
          component: Image,
          children: [
            {
              path: '/',
              name: 'ImageList',
              component: ImageList,
              meta: {
                title: 'Danh sách hình ảnh - CLICKBUY',
              },
            },
            {
              path: '/images/upload',
              name: 'ImageUpload',
              component: ImageUpload,
              meta: {
                title: 'Tải lên hình ảnh - CLICKBUY',
              },
            },
            {
              path: '/images/:id',
              name: 'ImageDetail',
              component: ImageDetail,
              meta: {
                title: 'Chi tiết hình ảnh - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/inventory-receipt',
          component: InventoryReceipt,
          meta: {
            stockSlipListMode: 'manual',
          },
          children: [
            {
              path: '/',
              name: 'list-inventory-receipt',
              component: InventoryReceiptList,
              meta: {
                title: 'Danh sách phiếu nhập kho',
                stockSlipListMode: 'manual',
              },
            },
            {
              path: 'add-inventory-receipt',
              name: 'add-inventory-receipt',
              component: InventoryReceiptForm,
              meta: {
                title: 'Thêm mới phiếu nhập kho',
              },
            },
            {
              path: 'edit-inventory-receipt',
              name: 'edit-inventory-receipt',
              component: InventoryReceiptForm,
              meta: {
                title: 'Cập nhật phiếu nhập kho',
              },
            },
            {
              path: 'print-receipt-invoice',
              name: 'print-receipt-invoice',
              component: StockSlipInvoice,
              meta: {
                title: 'In phiếu kho',
              },
            },
          ],
        },
        {
          path: '/inventory-receipt-auto',
          component: InventoryReceipt,
          meta: {
            stockSlipListMode: 'auto',
          },
          children: [
            {
              path: '/',
              name: 'list-inventory-receipt-auto',
              component: InventoryReceiptList,
              meta: {
                title: 'Danh sách phiếu nhập từ đơn hàng',
                stockSlipListMode: 'auto',
              },
            },
            {
              path: 'view-inventory-receipt',
              name: 'view-inventory-receipt-auto',
              component: InventoryReceiptForm,
              meta: {
                title: 'Chi tiết phiếu nhập từ đơn hàng',
                stockSlipListMode: 'auto',
              },
            },
            {
              path: 'print-receipt-invoice',
              name: 'print-receipt-invoice-auto',
              component: StockSlipInvoice,
              meta: {
                title: 'In phiếu kho',
                stockSlipListMode: 'auto',
              },
            },
          ],
        },
        {
          path: '/inventory-dispatch',
          component: InventoryDispatch,
          meta: {
            stockSlipListMode: 'manual',
          },
          children: [
            {
              path: '/',
              name: 'list-inventory-dispatch',
              component: InventoryDispatchList,
              meta: {
                title: 'Danh sách phiếu xuất kho',
                stockSlipListMode: 'manual',
              },
            },
            {
              path: 'add-inventory-dispatch',
              name: 'add-inventory-dispatch',
              component: InventoryDispatchForm,
              meta: {
                title: 'Thêm mới phiếu xuất kho',
              },
            },
            {
              path: 'edit-inventory-dispatch',
              name: 'edit-inventory-dispatch',
              component: InventoryDispatchForm,
              meta: {
                title: 'Cập nhật phiếu xuất kho',
              },
            },
            {
              path: 'print-dispatch-invoice',
              name: 'print-dispatch-invoice',
              component: StockSlipInvoice,
              meta: {
                title: 'In phiếu kho',
              },
            },
          ],
        },
        {
          path: '/inventory-dispatch-auto',
          component: InventoryDispatch,
          meta: {
            stockSlipListMode: 'auto',
          },
          children: [
            {
              path: '/',
              name: 'list-inventory-dispatch-auto',
              component: InventoryDispatchList,
              meta: {
                title: 'Danh sách phiếu xuất từ đơn hàng',
                stockSlipListMode: 'auto',
              },
            },
            {
              path: 'view-inventory-dispatch',
              name: 'view-inventory-dispatch-auto',
              component: InventoryDispatchForm,
              meta: {
                title: 'Chi tiết phiếu xuất từ đơn hàng',
                stockSlipListMode: 'auto',
              },
            },
            {
              path: 'print-dispatch-invoice',
              name: 'print-dispatch-invoice-auto',
              component: StockSlipInvoice,
              meta: {
                title: 'In phiếu kho',
                stockSlipListMode: 'auto',
              },
            },
          ],
        },
        {
          path: '/inventory-transfer',
          component: InventoryTransfer,
          children: [
            {
              path: '/',
              name: 'list-inventory-transfer',
              component: InventoryTransferList,
              meta: {
                title: 'Danh sách phiếu chuyển kho',
              },
            },
            {
              path: 'add-inventory-transfer',
              name: 'add-inventory-transfer',
              component: InventoryTransferForm,
              meta: {
                title: 'Thêm mới phiếu chuyển kho',
              },
            },
            {
              path: 'edit-inventory-transfer',
              name: 'edit-inventory-transfer',
              component: InventoryTransferForm,
              meta: {
                title: 'Cập nhật phiếu chuyển kho',
              },
            },
            {
              path: 'approval-inventory-transfer',
              name: 'approval-inventory-transfer',
              component: InventoryTransferApproval,
              meta: {
                title: 'Duyệt phiếu chuyển kho',
              },
            },
            {
              path: 'confirm-inventory-transfer',
              name: 'confirm-inventory-transfer',
              component: InventoryTransferConfirm,
              meta: {
                title: 'Xác nhận phiếu chuyển kho',
              },
            },
            {
              path: 'print-inventory-transfer',
              name: 'print-inventory-transfer',
              component: PrintInventoryTransfer,
              meta: {
                title: 'In phiếu kho chuyển kho',
              },
            },
          ],
        },
        {
          path: '/request-transfer',
          component: RequestTransfer,
          children: [
            {
              path: '/',
              name: 'list-request-transfer',
              component: RequestTransferList,
              meta: {
                title: 'Danh sách phiếu yêu cầu chuyển kho',
              },
            },
            {
              path: 'add-request-transfer',
              name: 'add-request-transfer',
              component: RequestTransferForm,
              meta: {
                title: 'Thêm mới phiếu yêu cầu chuyển kho',
              },
            },
            {
              path: 'edit-request-transfer',
              name: 'edit-request-transfer',
              component: RequestTransferForm,
              meta: {
                title: 'Cập nhật phiếu yêu cầu chuyển kho',
              },
            },
          ],
        },
        {
          path: '/defective-goods-transfer',
          component: DefectiveGoodsTransfer,
          children: [
            {
              path: '/',
              name: 'list-defective-goods-transfer',
              component: DefectiveGoodsTransferList,
              meta: {
                title: 'Danh sách phiếu nhập hàng lỗi',
              },
            },
            {
              path: 'add-defective-goods-transfer',
              name: 'add-defective-goods-transfer',
              component: DefectiveGoodsTransferForm,
              meta: {
                title: 'Thêm mới phiếu nhập hàng lỗi',
              },
            },
            {
              path: 'edit-defective-goods-transfer',
              name: 'edit-defective-goods-transfer',
              component: DefectiveGoodsTransferForm,
              meta: {
                title: 'Cập nhật phiếu nhập hàng lỗi',
              },
            },
          ],
        },
        {
          path: '/defective-goods-export',
          component: DefectiveGoodsExport,
          children: [
            {
              path: '/',
              name: 'list-defective-goods-export',
              component: DefectiveGoodsExportList,
              meta: {
                title: 'Danh sách phiếu xuất hàng lỗi',
              },
            },
            {
              path: 'add-defective-goods-export',
              name: 'add-defective-goods-export',
              component: DefectiveGoodsExportForm,
              meta: {
                title: 'Thêm mới phiếu xuất hàng lỗi',
              },
            },
            {
              path: 'edit-defective-goods-export',
              name: 'edit-defective-goods-export',
              component: DefectiveGoodsExportForm,
              meta: {
                title: 'Cập nhật phiếu xuất hàng lỗi',
              },
            },
          ],
        },
        {
          path: '/defective-goods-restoration',
          component: DefectiveGoodsRestoration,
          children: [
            {
              path: '/',
              name: 'list-defective-goods-restoration',
              component: DefectiveGoodsRestorationList,
              meta: {
                title: 'Danh sách phiếu phục hồi hàng lỗi',
              },
            },
            {
              path: 'add-defective-goods-restoration',
              name: 'add-defective-goods-restoration',
              component: DefectiveGoodsRestorationForm,
              meta: {
                title: 'Thêm mới phiếu phục hồi hàng lỗi',
              },
            },
            {
              path: 'edit-defective-goods-restoration',
              name: 'edit-defective-goods-restoration',
              component: DefectiveGoodsRestorationForm,
              meta: {
                title: 'Cập nhật phiếu phục hồi hàng lỗi',
              },
            },
          ],
        },
        {
          path: '/lending-stockslip',
          component: LendingStockslip,
          children: [
            {
              path: '/',
              name: 'list-lending-stockslip',
              component: LendingStockslipList,
              meta: {
                title: 'Danh sách phiếu cho mượn',
              },
            },
            {
              path: 'add-lending-stockslip',
              name: 'add-lending-stockslip',
              component: LendingStockslipForm,
              meta: {
                title: 'Thêm mới phiếu cho mượn',
              },
            },
            {
              path: 'edit-lending-stockslip',
              name: 'edit-lending-stockslip',
              component: LendingStockslipForm,
              meta: {
                title: 'Cập nhật phiếu cho mượn',
              },
            },
            {
              path: 'print-lending-stockslip',
              name: 'print-lending-stockslip',
              component: () => import('@/view/pages/lending-stockslip/Print.vue'),
              meta: {
                title: 'In phiếu cho mượn',
              },
            },
          ],
        },
        {
          path: '/purchase-orders',
          component: () => import('@/view/pages/purchase-orders/PurchaseOrder.vue'),
          children: [
            {
              path: '/',
              name: 'list-purchase-orders',
              component: () => import('@/view/pages/purchase-orders/List.vue'),
              meta: {
                title: 'Phiếu yêu cầu nhập hàng - CLICKBUY',
              },
            },
            {
              path: 'info-purchase-orders',
              name: 'info-purchase-orders',
              component: () => import('@/view/pages/purchase-orders/Info.vue'),
              meta: {
                title: 'Thông tin phiếu yêu cầu nhập hàng - CLICKBUY',
              },
            },
            {
              path: 'share-purchase-orders',
              name: 'share-purchase-orders',
              component: () => import('@/view/pages/purchase-orders/POShare.vue'),
              meta: {
                title: 'Thông tin phiếu yêu cầu nhập hàng - CLICKBUY',
              },
            },
            {
              path: 'update-purchase-orders',
              name: 'update-purchase-orders',
              component: () => import('@/view/pages/purchase-orders/Info.vue'),
              meta: {
                title: 'Thông tin phiếu yêu cầu nhập hàng - CLICKBUY',
              },
            },
            {
              path: 'approve-purchase-orders',
              name: 'approve-purchase-orders',
              component: () => import('@/view/pages/purchase-orders/Approve.vue'),
              meta: {
                title: 'Duyệt phiếu yêu cầu nhập hàng - CLICKBUY',
              },
            },
            {
              path: 'print-purchase-orders',
              name: 'print-purchase-orders',
              component: () => import('@/view/pages/purchase-orders/Print.vue'),
              meta: {
                title: 'In phiếu yêu cầu nhập hàng - CLICKBUY',
              },
            },
            {
              path: 'approve-po-share',
              name: 'approve-po-share',
              component: () => import('@/view/pages/purchase-orders/ApprovePOShare.vue'),
              meta: {
                title: 'Duyệt phiếu PO chia hàng - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/solutions',
          component: () => import('@/view/pages/solution/Solution.vue'),
          children: [
            {
              path: '/',
              name: 'SolutionList',
              component: () => import('@/view/pages/solution/SolutionList.vue'),
              meta: {
                title: 'Danh sách phương án xử lý bảo hành - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/warranty-services',
          component: () => import('@/view/pages/warranty-service/WarrantyService.vue'),
          children: [
            {
              path: '/',
              name: 'WarrantyServiceList',
              component: () => import('@/view/pages/warranty-service/WarrantyServiceList.vue'),
              meta: {
                title: 'Danh sách loại dịch vụ - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/error-severity',
          component: () => import('@/view/pages/error-severity/ErrorSeverity.vue'),
          children: [
            {
              path: '/',
              name: 'ErrorSeverityList',
              component: () => import('@/view/pages/error-severity/ErrorSeverityList.vue'),
              meta: {
                title: 'Danh sách mức độ lỗi - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/error-group',
          component: () => import('@/view/pages/error-group/ErrorGroup.vue'),
          children: [
            {
              path: '/',
              name: 'ErrorGroupList',
              component: () => import('@/view/pages/error-group/ErrorGroupList.vue'),
              meta: {
                title: 'Danh sách nhóm lỗi - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/technical-error',
          component: () => import('@/view/pages/technical-error/TechnicalError.vue'),
          children: [
            {
              path: '/',
              name: 'TechnicalErrorList',
              component: () => import('@/view/pages/technical-error/TechnicalErrorList.vue'),
              meta: {
                title: 'Danh sách lỗi kỹ thuật - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/accompanying-equipment',
          component: () => import('@/view/pages/accompanying-equipment/AccompanyingEquipment.vue'),
          children: [
            {
              path: '/',
              name: 'AccompanyingEquipmentList',
              component: () =>
                import('@/view/pages/accompanying-equipment/AccompanyingEquipmentList.vue'),
              meta: {
                title: 'Danh sách thiết bị kèm theo - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/companies',
          component: () => import('@/view/pages/companies/Company.vue'),
          children: [
            {
              path: '/',
              name: 'list-company',
              component: () => import('@/view/pages/companies/List.vue'),
              meta: {
                title: 'Danh sách doanh nghiệp',
              },
            },
          ],
        },
        {
          path: '/reward',
          component: () => import('@/view/pages/reward/Reward.vue'),
          children: [
            {
              path: 'reward-category',
              name: 'reward-category',
              component: () => import('@/view/pages/reward/ListRewardCategory.vue'),
              meta: {
                title: 'Danh sách nhóm sản phẩm hoa hồng - CLICKBUY',
              },
            },
            {
              path: 'reward-program',
              name: 'reward-program',
              component: () => import('@/view/pages/reward/ListRewardProgram.vue'),
              meta: {
                title: 'Danh sách chương trình thưởng thưởng hoa hồng NCH - CLICKBUY',
              },
            },
            {
              path: 'add-reward-category',
              name: 'add-reward-category',
              component: () => import('@/view/pages/reward/UpsertRewardCategory.vue'),
              meta: {
                title: 'Thêm mới nhóm sản phẩm hoa hồng - CLICKBUY',
              },
            },
            {
              path: 'update-reward-category',
              name: 'update-reward-category',
              component: () => import('@/view/pages/reward/UpsertRewardCategory.vue'),
              meta: {
                title: 'Cập nhật nhóm sản phẩm hoa hồng - CLICKBUY',
              },
            },
            {
              path: 'add-reward-program',
              name: 'add-reward-program',
              component: () => import('@/view/pages/reward/UpsertRewardProgram.vue'),
              meta: {
                title: 'Thêm mới chương trình thưởng hoa hồng - CLICKBUY',
              },
            },
            {
              path: 'update-reward-program',
              name: 'update-reward-program',
              component: () => import('@/view/pages/reward/UpsertRewardProgram.vue'),
              meta: {
                title: 'Cập nhật chương trình thưởng hoa hồng - CLICKBUY',
              },
            },
            {
              path: 'reward-detail',
              name: 'reward-detail',
              component: () => import('@/view/pages/reward/ListRewardDetail.vue'),
              meta: {
                title: 'Cộng trừ khác hoa hồng cửa hàng - CLICKBUY',
              },
            },
            {
              path: 'reward-check',
              name: 'reward-check',
              component: () => import('@/view/pages/reward/RewardCheck.vue'),
              meta: {
                title: 'Kiểm tra sản phẩm tính hoa hồng ngành cửa hàng',
              },
            },
          ],
        },
        {
          path: '/reward-reports',
          component: () => import('@/view/pages/reward-report/RewardReport.vue'),
          children: [
            {
              path: 'overview',
              name: 'overview',
              component: () => import('@/view/pages/reward-report/Overview.vue'),
              meta: {
                title: 'Báo cáo hoa hồng tổng hợp',
              },
            },
          ],
        },
        {
          path: '/reward-cr-reports',
          component: () => import('@/view/pages/reward-cr-report/RewardCRReport.vue'),
          children: [
            {
              path: 'overview',
              name: 'overview',
              component: () => import('@/view/pages/reward-cr-report/Overview.vue'),
              meta: {
                title: 'Báo cáo hoa hồng CSKH - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/stores',
          component: Store,
          children: [
            {
              path: '/',
              name: 'list-store',
              component: ListStore,
              meta: {
                title: 'Danh sách cửa hàng',
              },
            },
            {
              path: 'add-store',
              name: 'add-store',
              component: StoreInfo,
              meta: {
                title: 'Thêm mới cửa hàng',
              },
            },
            {
              path: 'edit-store',
              name: 'edit-store',
              component: StoreInfo,
              meta: {
                title: 'Cập nhật cửa hàng',
              },
            },
          ],
        },
        {
          path: '/transfer-store-forms',
          component: () => import('@/view/pages/transfer-store-forms/TransferStoreForm.vue'),
          children: [
            {
              path: '/',
              component: () =>
                import('@/view/pages/transfer-store-forms/ListTransferStoreForms.vue'),
              name: 'list-transfer-store-forms',
              meta: {
                title: 'Phiếu chuyển cửa hàng',
              },
            },
            {
              path: 'add-form',
              name: 'add-transfer-store-form',
              component: () => import('@/view/pages/transfer-store-forms/AddTransferStoreForm.vue'),
              meta: {
                title: 'Tạo mới đơn chuyển cửa hàng',
              },
            },
            {
              path: 'edit-form',
              name: 'edit-transfer-store-form',
              component: () =>
                import('@/view/pages/transfer-store-forms/EditTransferStoreForm.vue'),
              meta: {
                title: 'Xem chi tiết đơn chuyển cửa hàng',
              },
            },
          ],
        },
        {
          path: '/employees',
          component: Employee,
          children: [
            {
              path: '/',
              name: 'list-employee',
              component: ListEmployee,
              meta: {
                title: 'Danh sách nhân sự',
              },
            },
            {
              path: 'upsert-employee',
              name: 'upsert-employee',
              component: UpsertEmployee,
              meta: {
                title: 'Thông tin nhân sự',
              },
            },
            {
              path: 'import-excel-employee',
              name: 'import-excel-employee',
              component: ImportExcelEmployee,
              meta: {
                title: 'Import nhân sự từ file Excel',
              },
            },
          ],
        },
        {
          path: '/permissions',
          component: Permission,
          children: [
            {
              path: '/',
              name: 'list-permissions',
              component: ListPermission,
              meta: {
                title: 'Danh sách quyền',
              },
            },
            {
              path: 'upsert-permission',
              name: 'upsert-permission',
              component: UpsertPermissionV2,
              meta: {
                title: 'Thông tin quyền',
              },
            },
            //TODO remove after UpsertPermissionV2 stable
            {
              path: 'upsert-permission-v1',
              name: 'upsert-permission-v1',
              component: UpsertPermission,
              meta: {
                title: 'Thông tin quyền (V1 - Legacy)',
              },
            },
            {
              path: 'day-limit-job-title',
              name: 'day-limit-job-title',
              component: DayLimitJobTitleUpsert,
              meta: {
                title: 'Cấu hình giới hạn ngày',
              },
            },
          ],
        },
        {
          path: '/users',
          component: User,
          children: [
            {
              path: '/',
              name: 'list-user',
              component: ListUser,
              meta: {
                title: 'Danh sách tài khoản',
              },
            },
            {
              path: 'add-user',
              name: 'add-user',
              component: AddUser,
              meta: {
                title: 'Thêm mới tài khoản',
              },
            },
            {
              path: 'update-user',
              name: 'update-user',
              component: UpdateUser,
              meta: {
                title: 'Cập nhật tài khoản',
              },
            },
          ],
        },
        ...AccountantRoutes,
        ...TransactionCategoryRoutes,
        {
          path: '/customers',
          component: Customer,
          children: [
            {
              path: '/',
              name: 'list-customer',
              component: ListCustomer,
              meta: {
                title: 'Danh sách khách hàng',
              },
            },
            {
              path: 'add-customer',
              name: 'add-customer',
              component: AddCustomer,
              meta: {
                title: 'Thêm mới khách hàng',
              },
            },
            {
              path: 'update-customer',
              name: 'update-customer',
              component: UpdateCustomer,
              meta: {
                title: 'Cập nhật khách hàng',
              },
            },
          ],
        },
        {
          path: '/voucher',
          component: () => import('@/view/pages/voucher/Voucher.vue'),
          children: [
            {
              path: '/',
              name: 'list-voucher',
              component: () => import('@/view/pages/voucher/List.vue'),
              meta: {
                title: 'Danh sách voucher - Clickbuy',
              },
            },
            {
              path: 'add-voucher',
              name: 'add-voucher',
              component: () => import('@/view/pages/voucher/Info.vue'),
              meta: {
                title: 'Thêm mới voucher - Clickbuy',
              },
            },
            {
              path: 'update-voucher',
              name: 'update-voucher',
              component: () => import('@/view/pages/voucher/Info.vue'),
              meta: {
                title: 'Cập nhật voucher - Clickbuy',
              },
            },
          ],
        },
        {
          path: '/accessories',
          component: () => import('@/view/pages/accessories/Accessory.vue'),
          children: [
            {
              path: '/',
              name: 'list-accessory',
              component: () => import('@/view/pages/accessories/ListAccessory.vue'),
              meta: {
                title: 'Danh sách bộ sản phẩm tặng kèm - Clickbuy',
              },
            },
            {
              path: 'add-accessory',
              name: 'add-accessory',
              component: () => import('@/view/pages/accessories/AddAccessory.vue'),
              meta: {
                title: 'Thêm mới bộ sản phẩm tặng kèm - Clickbuy',
              },
            },
            {
              path: 'update-accessory',
              name: 'update-accessory',
              component: () => import('@/view/pages/accessories/UpdateAccessory.vue'),
              meta: {
                title: 'Cập nhật bộ sản phẩm tặng kèm - Clickbuy',
              },
            },
          ],
        },
        {
          path: '/promotion-accessories',
          component: () => import('@/view/pages/promotion-accessories/PromotionAcc.vue'),
          children: [
            {
              path: '/',
              name: 'list-promotion-accessories',
              component: () => import('@/view/pages/promotion-accessories/ListPromotionAcc.vue'),
              meta: {
                title: 'Danh sách bộ sản phẩm khuyến mãi - Clickbuy',
              },
            },
            {
              path: 'upsert-promotion-accessories',
              name: 'upsert-promotion-accessories',
              component: () => import('@/view/pages/promotion-accessories/UpsertPromotion.vue'),
              meta: {
                title: 'Thông tin bộ sản phẩm khuyến mãi - Clickbuy',
              },
            },
          ],
        },
        {
          path: '/warranty-packages',
          component: () => import('@/view/pages/warranty-package/WarrantyPackage.vue'),
          children: [
            {
              path: '/',
              name: 'list-warranty-packages',
              component: () => import('@/view/pages/warranty-package/List.vue'),
              meta: {
                title: 'Danh sách gói bảo hành - Clickbuy',
              },
            },
            {
              path: 'add-warranty-package',
              name: 'add-warranty-package',
              component: () => import('@/view/pages/warranty-package/WarrantyPackageInfo.vue'),
              meta: {
                title: 'Thêm mới gói bảo hành - Clickbuy',
              },
            },
            {
              path: 'update-warranty-package',
              name: 'update-warranty-package',
              component: () => import('@/view/pages/warranty-package/WarrantyPackageInfo.vue'),
              meta: {
                title: 'Cập nhật gói bảo hành - Clickbuy',
              },
            },
          ],
        },
        {
          path: '/discount-programs',
          component: () => import('@/view/pages/discount-program/DiscountProgram.vue'),
          children: [
            {
              path: '/',
              name: 'list-discount-program',
              component: () => import('@/view/pages/discount-program/List.vue'),
              meta: {
                title: 'Danh sách chương trình chiết khấu - Clickbuy',
              },
            },
            {
              path: 'add',
              name: 'add-discount-program',
              component: () => import('@/view/pages/discount-program/Add.vue'),
              meta: {
                title: 'Thêm mới chương trình chiết khấu - Clickbuy',
              },
            },
            {
              path: 'update/:discountProgramId',
              name: 'update-discount-program',
              component: () => import('@/view/pages/discount-program/Update.vue'),
              meta: {
                title: 'Cập nhật chương trình chiết khấu - Clickbuy',
              },
            },
            {
              path: 'upsert-discount-program',
              name: 'upsert-discount-program',
              component: () => import('@/view/pages/discount-program/Upsert.vue'),
              meta: {
                title: 'Chương trình chiết khấu - Clickbuy',
              },
            },
          ],
        },
        ...providerRouters,
        ...approvalConfigRoutes,
        ...approvalRouter,
        ...reportRouters,
        ...debtRouters,
        ...supplierGroupRouters,
        ...customerTypeRouters,
        ...einvoiceRoutes,
        ...accessSettingsRouters,
        {
          path: 'disbursement',
          component: () => import('@/view/pages/disbursement/Disbursement.vue'),
          children: [
            {
              path: '/',
              name: 'list-disbursement',
              component: () => import('@/view/pages/disbursement/ListDisbursement.vue'),
              meta: {
                title: 'Danh sách giải ngân công nợ - CLICKBUY',
              },
            },
            {
              path: 'add',
              name: 'add-disbursement',
              component: () => import('@/view/pages/disbursement/UpsertDisbursement.vue'),
              meta: {
                title: 'Tạo danh sách giải ngân công nợ - CLICKBUY',
              },
            },
            {
              path: 'update/:id',
              name: 'update-disbursement',
              component: () => import('@/view/pages/disbursement/UpsertDisbursement.vue'),
              meta: {
                title: 'Cập nhật danh sách giải ngân công nợ - CLICKBUY',
              },
              props: true,
            },
            {
              path: 'configs',
              name: 'list-disbursement-configs',
              component: () =>
                import('@/view/pages/disbursement/configs/ListDisbursementConfigs.vue'),
              meta: {
                title: 'Cấu hình nhà giải ngân - CLICKBUY',
              },
            },
            {
              path: 'configs/add',
              name: 'add-disbursement-config',
              component: () =>
                import('@/view/pages/disbursement/configs/UpsertDisbursementConfig.vue'),
              meta: {
                title: 'Thêm cấu hình nhà giải ngân - CLICKBUY',
              },
            },
            {
              path: 'configs/update/:id',
              name: 'update-disbursement-config',
              component: () =>
                import('@/view/pages/disbursement/configs/UpsertDisbursementConfig.vue'),
              meta: {
                title: 'Sửa cấu hình nhà giải ngân - CLICKBUY',
              },
              props: true,
            },
          ],
        },
        {
          path: '/bills',
          component: Bill,
          children: [
            {
              path: '/',
              name: 'list-bill',
              component: ListBill,
              meta: {
                title: 'Danh sách hóa đơn bán lẻ',
              },
              props: { billType: 1 },
            },
            {
              path: 'add-bill',
              name: 'add-bill',
              component: () => import('@/view/pages/bills/BillInfoV2.vue'),
              meta: {
                title: 'Thêm mới hóa đơn bán lẻ',
              },
              props: { billType: 1 },
            },
            {
              path: 'update-bill',
              name: 'update-bill',
              component: () => import('@/view/pages/bills/BillInfoV2.vue'),
              meta: {
                title: 'Cập nhật hóa đơn bán lẻ',
              },
              props: { billType: 1 },
            },
            {
              path: 'print-bill',
              name: 'print-bill',
              component: () => import('@/view/pages/bills/PrintBill.vue'),
              meta: {
                title: 'In hóa đơn',
              },
            },
          ],
        },
        {
          path: '/delivery-bills',
          component: Bill,
          children: [
            {
              path: '/',
              name: 'list-delivery-bill',
              component: ListBill,
              meta: {
                title: 'Danh sách hóa đơn giao hàng',
              },
              props: { billType: 4 },
            },
            {
              path: 'update-delivery-bill',
              name: 'update-delivery-bill',
              component: () => import('@/view/pages/bills/BillInfoV2.vue'),
              meta: {
                title: 'Chi tiết hóa đơn giao hàng',
              },
              props: { billType: 4 },
            },
          ],
        },
        {
          path: '/wholesale-invoice',
          component: WholesaleInvoice,
          children: [
            {
              path: '/',
              name: 'list-wholesale-invoice',
              component: ListBill,
              meta: {
                title: 'Danh sách hóa đơn bán buôn',
              },
              props: { billType: 2 },
            },
            {
              path: 'add-wholesale-invoice',
              name: 'add-wholesale-invoice',
              component: () => import('@/view/pages/bills/BillWholesaleInfo.vue'),
              meta: {
                title: 'Thêm mới hóa đơn bán buôn',
              },
              props: { billType: 2 },
            },
            {
              path: 'update-wholesale-invoice',
              name: 'update-wholesale-invoice',
              component: () => import('@/view/pages/bills/BillWholesaleInfo.vue'),
              meta: {
                title: 'Cập nhật hóa đơn bán buôn',
              },
              props: { billType: 2 },
            },
            {
              path: 'print-bill',
              name: 'print-wholesale-invoice',
              component: () => import('@/view/pages/bills/PrintBill.vue'),
              meta: {
                title: 'In hóa đơn bán buôn',
              },
            },
            {
              path: 'print-documents',
              name: 'print-bill-documents',
              component: () => import('@/view/pages/bills/PrintBillDocuments.vue'),
              meta: {
                title: 'In tài liệu hóa đơn',
              },
            },
          ],
        },
        {
          path: '/refund-bills',
          component: RefundBill,
          children: [
            {
              path: '/',
              name: 'list-refund-bill',
              component: () => import('@/view/pages/bills/refunds/List.vue'),
              meta: {
                title: 'Danh sách hóa đơn trả hàng',
              },
              props: { billType: 3 },
            },
            {
              path: 'refund-bill',
              name: 'refund-bill',
              component: () => import('@/view/pages/bills/refunds/RefundInfo.vue'),
              meta: {
                title: 'Trả hàng',
              },
            },
            {
              path: 'update-refund-bill',
              name: 'update-refund-bill',
              component: () => import('@/view/pages/bills/refunds/RefundInfo.vue'),
              meta: {
                title: 'Cập nhật hóa đơn trả hàng',
              },
            },
          ],
        },
        {
          path: '/exchange-bills',
          component: ExchangeBill,
          children: [
            {
              path: 'exchange-bill',
              name: 'exchange-bill',
              component: () => import('@/view/pages/bills/exchange/ExchangeInfo.vue'),
              meta: {
                title: 'Xuất đổi sản phẩm',
              },
            },
          ],
        },
        {
          path: '/settings',
          component: Setting,
          children: [
            {
              path: '/',
              name: 'setting-info',
              component: SettingInfo,
              meta: {
                title: 'Cài đặt',
              },
            },
            {
              path: 'shipping-carriers',
              name: 'setting-shipping-carriers',
              component: ShippingCarrierSettings,
              meta: {
                title: 'Cài đặt nhà vận chuyển',
              },
            },
          ],
        },
        {
          path: '/stock-slip-reports',
          component: () => import('@/view/pages/stock-slips/reports/StockSlipReport.vue'),
          children: [
            {
              path: '/',
              name: 'stock-slip-reports',
              component: () => import('@/view/pages/stock-slips/reports/List.vue'),
              meta: {
                title: 'Báo cáo xuất nhập kho',
              },
            },
          ],
        },
        {
          path: '/opening-stock-receipt',
          component: OpeningStockReceipt,
          children: [
            {
              path: '/',
              name: 'opening-stock-receipt-list',
              component: OpeningStockReceiptList,
              meta: {
                title: 'Danh sách phiếu nhập kho đầu kỳ - CLICKBUY',
              },
            },
            {
              path: 'add-opening-stock-receipt',
              name: 'add-opening-stock-receipt',
              component: OpeningStockReceiptForm,
              meta: {
                title: 'Thêm phiếu nhập kho đầu kỳ - CLICKBUY',
              },
            },
            {
              path: 'update-opening-stock-receipt',
              name: 'update-opening-stock-receipt',
              component: OpeningStockReceiptForm,
              meta: {
                title: 'Cập nhật phiếu nhập kho đầu kỳ - CLICKBUY',
              },
            },
            {
              path: 'add-opening-imei-stock-receipt',
              name: 'add-opening-imei-stock-receipt',
              component: OpeningStockReceiptIMEIForm,
              meta: {
                title: 'Thêm IMEI nhập kho đầu kỳ - CLICKBUY',
              },
            },
            {
              path: 'update-opening-imei-stock-receipt',
              name: 'update-opening-imei-stock-receipt',
              component: OpeningStockReceiptIMEIForm,
              meta: {
                title: 'Cập nhật IMEI nhập kho đầu kỳ - CLICKBUY',
              },
            },
          ],
        },
        {
          path: '/platform-integration',
          component: () => import('@/view/pages/platform-integration/PlatformIntegration.vue'),
          children: [
            {
              path: '/',
              name: 'platform-integration-list',
              component: () => import('@/view/pages/platform-integration/PlatformListPage.vue'),
              meta: {
                title: 'Danh sách kết nối sàn TMĐT - CLICKBUY',
                requiresAuth: true,
              },
            },
            {
              path: 'connect',
              name: 'platform-integration-connect',
              component: () => import('@/view/pages/platform-integration/PlatformConnectPage.vue'),
              meta: {
                title: 'Kết nối sàn TMĐT - CLICKBUY',
                requiresAuth: true,
              },
            },
            {
              path: 'callback/:platform',
              name: 'platform-integration-callback',
              component: () => import('@/view/pages/platform-integration/OAuthCallbackPage.vue'),
              meta: {
                title: 'Xử lý kết nối - CLICKBUY',
                requiresAuth: true,
              },
            },
            {
              path: 'shop-selection',
              name: 'platform-integration-shop-selection',
              component: () => import('@/view/pages/platform-integration/ShopSelectionPage.vue'),
              meta: {
                title: 'Chọn gian hàng - CLICKBUY',
                requiresAuth: true,
              },
            },
            {
              path: 'success',
              name: 'platform-integration-success',
              component: () => import('@/view/pages/platform-integration/PlatformSuccessPage.vue'),
              meta: {
                title: 'Kết nối thành công - CLICKBUY',
                requiresAuth: true,
              },
            },
            {
              path: 'products',
              name: 'platform-integration-products',
              component: () =>
                import('@/view/pages/platform-integration/ProductManagementPage.vue'),
              meta: {
                title: 'Quản lý sản phẩm - CLICKBUY',
                requiresAuth: true,
              },
            },
            {
              path: 'orders',
              name: 'platform-integration-orders',
              component: () => import('@/view/pages/admin/shopee/OrderLogs'),
              meta: {
                title: 'Quản lý đơn hàng sàn - CLICKBUY',
                requiresAuth: true,
              },
            },
            {
              path: 'reports/pick-list',
              name: 'platform-integration-report-pick-list',
              component: () => import('@/view/pages/admin/shopee/reports/ShopeeReportPickList.vue'),
              meta: {
                title: 'Báo cáo Pick-list RTS - CLICKBUY',
                requiresAuth: true,
              },
            },
            {
              path: 'reports/order-report',
              name: 'platform-integration-report-order-report',
              component: () =>
                import('@/view/pages/admin/shopee/reports/ShopeeReportOrderReport.vue'),
              meta: {
                title: 'Báo cáo đơn hàng Shopee - CLICKBUY',
                requiresAuth: true,
              },
            },
            {
              path: 'reports/order-funnel',
              redirect: { name: 'platform-integration-report-order-report' },
            },
            {
              path: 'reports/by-marketplace',
              redirect: { name: 'platform-integration-report-order-report' },
            },
            {
              path: 'reports/profit-loss',
              name: 'platform-integration-report-profit-loss',
              component: () =>
                import('@/view/pages/admin/shopee/reports/ShopeeReportProfitLoss.vue'),
              meta: {
                title: 'Báo cáo lãi lỗ Shopee - CLICKBUY',
                requiresAuth: true,
              },
            },
            {
              path: 'reports/by-product',
              redirect: { name: 'platform-integration-report-profit-loss' },
            },
            {
              path: 'complaints',
              name: 'platform-integration-complaints',
              component: () => import('@/view/pages/admin/shopee/ComplaintListPage.vue'),
              meta: {
                title: 'Quản lý đơn khiếu nại - CLICKBUY',
                requiresAuth: true,
              },
            },
            {
              path: 'reconciliation',
              name: 'platform-integration-reconciliation',
              component: () => import('@/view/pages/admin/shopee/OrderReconciliationPage.vue'),
              meta: {
                title: 'Đối soát đơn hàng Shopee - CLICKBUY',
                requiresAuth: true,
              },
            },
            {
              path: ':id',
              name: 'platform-integration-detail',
              component: () => import('@/view/pages/platform-integration/PlatformDetailPage.vue'),
              meta: {
                title: 'Chi tiết kết nối - CLICKBUY',
                requiresAuth: true,
              },
            },
          ],
        },
      ],
    },
    {
      path: '/order-history',
      component: OrderHistory,
      children: [
        {
          path: 'list-order-history',
          name: 'list-order-history',
          component: ListOrderHistory,
          meta: {
            title: 'Lịch sử đơn hàng - CLICKBUY',
          },
        },
        {
          path: 'detail-order-history',
          name: 'detail-order-history',
          component: DetailOrderHistory,
          meta: {
            title: 'Chi tiết lịch sử đơn hàng - CLICKBUY',
          },
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/view/pages/auth/Auth'),
      children: [
        {
          name: 'login',
          path: '/login',
          component: () => import('@/view/pages/auth/RightSideLogin'),
          meta: {
            title: 'Đăng nhập · CLICKBUY',
            noFlex: true,
          },
        },
      ],
    },
    {
      path: '*',
      redirect: '/404',
    },
    {
      // the 404 route, when none of the above matches
      path: '/404',
      name: '404',
      component: () => import('@/view/pages/error/Error-1.vue'),
    },
  ],
})

export default router
